// extracted by mini-css-extract-plugin
module.exports = {"select":"LangDropdown_select__Jf7AX","select--top":"LangDropdown_select--top__8ZgwE","rotation":"LangDropdown_rotation___8j0s"};